import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var drawerWidth = 280;
export var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      height: "100%",
      zIndex: 1,
      overflow: "hidden",
      position: "relative",
      display: "flex"
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      background: "#0188cc",
      boxShadow: "0px 0px 0px 0px"
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth, "px)"),
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit
    },
    hide: {
      display: "none"
    },
    sideBarItem: {
      color: "green"
    },
    drawerPaper: {
      // backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/vrcore-6845f.appspot.com/o/images%2Fdrawerbg.jpg?alt=media&token=dc610e9e-d30c-43e7-88dd-ab044592ee25')",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 0",
      backgroundSize: "cover",
      // background:"rgba(1,43,65,.4)",
      //backgroundImage: "url('http://placekitten.com/1500/1000')",
      height: "100%",
      minHeight: "100vh",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      position: "relative",
      whiteSpace: "nowrap",
      borderRight: "0px solid #0188cc",
      boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"
    },
    drawerPaperClose: _defineProperty({
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: theme.spacing.unit * 7
    }, theme.breakpoints.up("sm"), {
      width: theme.spacing.unit * 9
    }),
    flex: {
      flex: 1
    },
    toolbar: _objectSpread({
      height: 76,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: "0 8px"
    }, theme.mixins.toolbar, {
      background: "#0188cc"
    }),
    toolbar2: _objectSpread({
      height: 76,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 8px"
    }, theme.mixins.toolbar),
    content: {
      position: "relative",
      flexGrow: 1,
      overflowX: "auto",
      backgroundColor: "#eee",
      padding: theme.spacing.unit * 3
    },
    button: {
      margin: theme.spacing.unit
    },
    leftIcon: {
      backgroundColor: "blue",
      marginRight: theme.spacing.unit
    },
    rightIcon: {
      marginLeft: theme.spacing.unit
    },
    iconSmall: {
      fontSize: 20
    }
  };
};